// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".numberCon[data-v-7d35b358]{text-align:center;padding:0 20px!important}.numberCon .num[data-v-7d35b358]{color:#006dcf;font-size:28px;padding-right:5px}", ""]);
// Exports
module.exports = exports;
